import React from 'react'
import { Route, Routes } from 'react-router-dom'
import ModulesPage from '../../pages/features/modules/ModulesPage'
import NewModulePage from '../../pages/features/modules/NewModulePage'
import UpdateModulePage from '../../pages/features/modules/UpdateModulePage'

export default function ModuleNav() {
    return (
        <Routes>
            <Route path="/" element={<ModulesPage />} />
            <Route path="/new" element={<NewModulePage />} />
            <Route path="/update" element={<UpdateModulePage />} />

        </Routes>
    )
}
